import React, { useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import { ShieldCheck, Calendar, Lock, Truck, XCircle, RotateCcw, PackageCheck } from 'lucide-react';
import InternationalPhoneInput from '../../components/Common/InternationalPhoneInput/InternationalPhoneInput';
import './PricingPage.css';

export default function PricingPage() {
  const [expandedCards, setExpandedCards] = useState({});
  const [form, setForm] = useState({
    name: '',
    phone: '',
    countryCode: '+91',
    email: '',
    city: '',
    message: ''
  });

  const toggleExpand = (key) => {
    setExpandedCards((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleInputChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for contacting Haatza! We will get in touch with you shortly.');
    setForm({ name: '', phone: '', countryCode: '+91', email: '', city: '', message: '' });
  };

  return (
    <div className="pricing-page-wrapper">
      <Navbar />

      {/* SECTION 1: HERO */}
      <section className="pricing-hero-section">
        <div className="container pricing-hero-grid-2">
          <div className="hero-copy">
            <h1 className="hero-heading">Pricing & Commission</h1>
            <p className="hero-subtext">
              Haatza charges <span className="highlight-blue">0% Commission</span> rate across all categories making it the most profitable platform for you to sell online.
            </p>
            <div className="hero-callout-simple pricing-gst-unique-box">
              <span className="new-badge-pill">NEW</span>
              <div className="gst-callout-text pricing-gst-unique-text-wrap">
                <div className="gst-callout-line pricing-gst-unique-line1">Don't have a GSTIN or have a Composition GSTIN?</div>
                <div className="gst-callout-line pricing-gst-unique-line2">You can still sell on Haatza. Click <a href="/donothavegst" className="highlight-blue underline font-semibold pricing-gst-unique-link">here</a> to know more.</div>
              </div>
            </div>
            <a href="/signin" style={{ textDecoration: 'none' }}>
              <button className="hero-cta-btn">Start Selling</button>
            </a>
          </div>

          <div className="hero-visual-container">
            <img
              src="https://static.wixstatic.com/media/fe689e_6b52712d5e6c443badf5e7748f028d07~mv2.jpg/v1/fill/w_848,h_534,fp_0.58_0.24,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/7f412c1c32.jpg"
              alt="Haatza Pricing Seller"
              className="hero-man-img"
            />
          </div>
        </div>
      </section>

      {/* SECTION 2: 3 BENEFIT CARDS (row) */}
      <section className="pricing-benefits-section">
        <div className="container">
          <div className="benefit-cards-grid-3">
            <div className="pricing-benefit-card">
              <div className="benefit-card-header-row">
                <div className="benefit-icon-badge bg-blue-100">
                  <img src="https://static.wixstatic.com/media/fe689e_ff13d5ee9bf94121ace155d8b35f59a5~mv2.jpg/v1/fill/w_67,h_66,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-01-22%20at%209_38_edited.jpg" alt="No Registration Fee" className="benefit-icon-img" />
                </div>
                <h3 className="benefit-card-title">No Registration Fee</h3>
              </div>
              <p className="benefit-card-desc">
                Registering as a Haatza seller is free - no cost of creating your account or getting your products listed.
              </p>
            </div>

            <div className="pricing-benefit-card">
              <div className="benefit-card-header-row">
                <div className="benefit-icon-badge bg-green-100">
                  <img src="https://static.wixstatic.com/media/fe689e_2378ac6785324d6a87177ac4caf8f209~mv2.jpg/v1/fill/w_86,h_64,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-01-22%20at%209_39_edited.jpg" alt="No Collection Fee" className="benefit-icon-img" />
                </div>
                <h3 className="benefit-card-title">No Collection Fee</h3>
              </div>
              <p className="benefit-card-desc">
                You keep 100% of the sale price with no charges on both payment gateway or cash on delivery orders on Haatza.
              </p>
            </div>

            <div className="pricing-benefit-card">
              <div className="benefit-card-header-row">
                <div className="benefit-icon-badge bg-purple-100">
                  <img src="https://static.wixstatic.com/media/fe689e_a82064c0e09547929b9635ab13631748~mv2.jpg/v1/fill/w_71,h_66,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-01-22%20at%209_37_edited.jpg" alt="No Penalty" className="benefit-icon-img" />
                </div>
                <h3 className="benefit-card-title">No Penalty</h3>
              </div>
              <p className="benefit-card-desc">
                Sell on Haatza stress-free without the fear of penalties for order cancellations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3: PAYMENT CYCLE */}
      <section className="payment-cycle-section light-blue-bg">
        <div className="container">
          <div className="payment-cycle-grid-2">
            <div className="cycle-copy">
              <h2 className="section-h2">Payment Cycle</h2>
              <p className="section-intro-text">
                The settlement amount is securely deposited directly into your bank account following a 7-day payment cycle from order delivery, including cash on delivery orders. You can view your deposited balance and the upcoming payments on the Haatza Supplier Panel.
              </p>
            </div>

            <div className="cycle-cards-stack">
              <div className="cycle-card">
                <div className="cycle-icon"><img src="https://static.wixstatic.com/media/fe689e_6ce5d46c27684429aacbdb42eab1e2ae~mv2.jpg/v1/fill/w_63,h_66,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-01-22%20at%209_43_edited.jpg" alt="7-day payment cycle" className="cycle-icon-img" /></div>
                <div className="cycle-card-body">
                  <h4 className="cycle-card-title">7-day payment cycle</h4>
                  <p className="cycle-card-desc">
                    Sellers at Haatza benefit from our commitment to a swift 7-day payment cycle. Enjoy prompt and consistent payments, making it easier for you to focus on growing your sales.
                  </p>
                </div>
              </div>

              <div className="cycle-card">
                <div className="cycle-icon"><img src="https://static.wixstatic.com/media/fe689e_7a93fae4dffa44e3968973e052feeefd~mv2.jpg/v1/fill/w_65,h_66,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-01-22%20at%209_43_edited.jpg" alt="Secured payment in your account" className="cycle-icon-img" /></div>
                <div className="cycle-card-body">
                  <h4 className="cycle-card-title">Secured payment in your account</h4>
                  <p className="cycle-card-desc">
                    Your safety is our top concern at Haatza. Enjoy a seamless selling experience with payments securely deposited into your account.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4: QUICK FACTS ON SHIPPING & DELIVERY */}
      <section className="quick-facts-section">
        <div className="container">
          <h2 className="section-h2 text-center mb-10">Quick Facts on Shipping & Delivery</h2>

          <div className="quick-facts-grid-4">
            {/* Fact Item 1 */}
            <div className="fact-clean-item">
              <div className="fact-img-wrapper">
                <img
                  src="https://static.wixstatic.com/media/11062b_33107fa62ffc4802857cdf8cad273dd2~mv2.jpg/v1/fill/w_400,h_286,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Woman%20packing%20her%20order%20for%20delivery.jpg"
                  alt="Woman packing order"
                  className="fact-img"
                />
              </div>
              <h4 className="fact-title text-center">Shipping</h4>
              <p className="fact-desc text-center">
                {expandedCards['fact1']
                  ? "Haatza's shipping service allows you to focus on selling, while we take care of the shipping and delivery with only 18% GST on the shipping charges. You can sell your products to crores of Haatza customers, schedule delivery with access to tens of thousands of local couriers, and have the flexibility to set your own prices."
                  : "Haatza's shipping service allows you to focus on selling, while we take care of the shipping and…"}
              </p>
              <button onClick={() => toggleExpand('fact1')} className="show-more-link center-link">
                {expandedCards['fact1'] ? 'Show Less' : 'Show More'}
              </button>
            </div>

            {/* Fact Item 2 */}
            <div className="fact-clean-item">
              <div className="fact-img-wrapper">
                <img
                  src="https://static.wixstatic.com/media/11062b_0578a4b184c34c5f8cb1244b3bb8d834~mv2.jpg/v1/fill/w_400,h_286,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/People%20Carrying%20Boxes.jpg"
                  alt="Delivery workers carrying boxes"
                  className="fact-img"
                />
              </div>
              <h4 className="fact-title text-center">Haatza Return Policy</h4>
              <p className="fact-desc text-center">
                {expandedCards['fact2']
                  ? "The Haatza Supplier Panel will provide visibility for returns on your inventory. This means you can  make adjustments in real-time and deliver a great customer experience and minimize your returns. Use the Panel to manage your returns and reduce your processing costs."
                  : "The Haatza Supplier Panel will provide visibility for returns on your inventory. This means you c…"}
              </p>
              <button onClick={() => toggleExpand('fact2')} className="show-more-link center-link">
                {expandedCards['fact2'] ? 'Show Less' : 'Show More'}
              </button>
            </div>

            {/* Fact Item 3 */}
            <div className="fact-clean-item">
              <div className="fact-img-wrapper">
                <img
                  src="https://static.wixstatic.com/media/11062b_84da0ee85db246d1b405d0c5090455e6~mv2.jpg/v1/fill/w_400,h_286,fp_0.62_0.32,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Online%20Orders.jpg"
                  alt="Man at desk checking phone"
                  className="fact-img"
                />
              </div>
              <h4 className="fact-title text-center">Cancellation</h4>
              <p className="fact-desc text-center">
                {expandedCards['fact3']
                  ? "Haatza charges 0 penalties for supplier cancellations and auto cancellations. For For situations when a supplier is not able to fulfil an order due to lack of inventory or any other unforeseen situation, suppliers can conduct their business tension-free on Haatza without worrying about the fear of paying penalties."
                  : "Haatza charges 0 penalties for supplier cancellations and auto cancellations. For …"}
              </p>
              <button onClick={() => toggleExpand('fact3')} className="show-more-link center-link">
                {expandedCards['fact3'] ? 'Show Less' : 'Show More'}
              </button>
            </div>

            {/* Fact Item 4 */}
            <div className="fact-clean-item">
              <div className="fact-img-wrapper">
                <img
                  src="https://static.wixstatic.com/media/11062b_99627a9f9e7f4f5b9078719aa3e11471~mv2.jpeg/v1/fill/w_400,h_286,fp_0.45_0.21,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Packaging%20of%20Order.jpeg"
                  alt="Woman writing notebook near boxes"
                  className="fact-img"
                />
              </div>
              <h4 className="fact-title text-center">Return to Origin</h4>
              <p className="fact-desc text-center">
                {expandedCards['fact4']
                  ? "The shipping partner will try three times to reach the customer. If the customer does not accept the product, it will be returned to you. Haatza will not charge a return shipping fee for any RTOs."
                  : "The shipping partner will try three times to reach the customer. If the customer does not accept …"}
              </p>
              <button onClick={() => toggleExpand('fact4')} className="show-more-link center-link">
                {expandedCards['fact4'] ? 'Show Less' : 'Show More'}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5: KEEP IN TOUCH FORM */}
      <section className="pricing-lead-form-section">
        <div className="container">
          <div className="lead-grid-2">
            <div className="lead-copy">
              <h2 className="lead-title">
                Sell Products Online at 0% Commission on Haatza
              </h2>
              <p className="lead-text">
                Join the fastest growing e-commerce platform in India and sell to crores of users and grow your business.
              </p>
              <a href="/signin" style={{ textDecoration: 'none' }}>
                <button className="lead-cta-btn">Start Selling</button>
              </a>
            </div>

            <div className="lead-form-wrapper">
              <h3 className="form-wrapper-title">Keep in touch</h3>
              <form onSubmit={handleFormSubmit} className="lead-form-element">
                <div className="form-field">
                  <label>Name*</label>
                  <input
                    type="text"
                    required
                    placeholder="Enter your first name"
                    value={form.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                  />
                </div>

                <div className="form-field">
                  <label>Phone*</label>
                  <InternationalPhoneInput
                    phone={form.phone}
                    onChangePhone={(val) => setForm(prev => ({ ...prev, phone: val }))}
                    countryCode={form.countryCode}
                    onChangeCountryCode={(code) => setForm(prev => ({ ...prev, countryCode: code }))}
                    required
                  />
                </div>

                <div className="form-field">
                  <label>Email</label>
                  <input
                    type="email"
                    placeholder="Enter email address"
                    value={form.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                  />
                </div>

                <div className="form-field">
                  <label>City*</label>
                  <input
                    type="text"
                    required
                    placeholder="Enter city"
                    value={form.city}
                    onChange={(e) => handleInputChange('city', e.target.value)}
                  />
                </div>

                <div className="form-field">
                  <label>Message</label>
                  <textarea
                    rows="3"
                    placeholder="Write your query here..."
                    value={form.message}
                    onChange={(e) => handleInputChange('message', e.target.value)}
                  ></textarea>
                </div>

                <button type="submit" className="form-submit-btn">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}